import { render } from "./safariGeneral.vue?vue&type=template&id=04afdb96"
import script from "./safariGeneral.vue?vue&type=script&lang=js"
export * from "./safariGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__